import { ModalControlsSaveableFactory } from '®shared/modals';

import {
  DeleteListActionTypes,
  DeleteListActions,
} from './delete-list.actions';
import {
  DELETE_LIST_INITIAL_STATE,
  DeleteListState,
} from './delete-list.state';

export function deleteListReducer(
  state: DeleteListState = DELETE_LIST_INITIAL_STATE,
  action: DeleteListActions,
): DeleteListState {
  switch (action.type) {
    case DeleteListActionTypes.DELETE_LIST_SHOW_MODAL: {
      return {
        modalControl: ModalControlsSaveableFactory.show(),
      };
    }

    case DeleteListActionTypes.DELETE_LIST: {
      return {
        modalControl: ModalControlsSaveableFactory.saving(),
      };
    }

    case DeleteListActionTypes.DELETE_LIST_FAILED: {
      return {
        modalControl: ModalControlsSaveableFactory.errorSaving(
          action.payload.error,
        ),
      };
    }

    case DeleteListActionTypes.DELETE_LIST_HIDE_MODAL: {
      return {
        ...DELETE_LIST_INITIAL_STATE,
        modalHiddenReason: action.payload.reason,
      };
    }

    default: {
      return state;
    }
  }
}
